;(function () {
  'use strict';
  function scrollTop() {
    var scrollTopBtn = $('#scrollTopBtn');
      scrollTopBtn.click(function() {
        $('body, html').animate({scrollTop: 0});
      })
  }
  $(function () {
    scrollTop();
  });

}.call(this));